import React from 'react';
import { cn } from '@strivelabs/ui-core';
import { Button } from '@strivelabs/ui-core/v2';
import { MessageCircle } from 'lucide-react';

export interface ChatCTABlockProps {
  /**
   * Banner text shown to the left of the button. When omitted, the component
   * renders the button alone (right-aligned), matching the action-button style
   * used inside `ContentListCard` items.
   */
  context?: string;
  buttonText?: string;
  onChatClick: () => void;
  className?: string;
}

export const ChatCTABlock: React.FC<ChatCTABlockProps> = ({
  context,
  buttonText = 'Chat Now',
  onChatClick,
  className,
}) => {
  // Button-only mode — no banner, right-aligned button matching content-list
  // item action styling (primary, size xs).
  if (!context) {
    return (
      <div className={cn('flex items-center justify-end gap-2', className)}>
        <Button size="xs" onClick={onChatClick}>
          <MessageCircle className="h-3.5 w-3.5" />
          {buttonText}
        </Button>
      </div>
    );
  }

  return (
    <div className={cn('rounded-xl border-[0.5px] border-custom overflow-hidden', className)}>
      <div className="relative min-h-[43px] px-4 py-3 flex items-center justify-between gap-3 overflow-hidden before:absolute before:inset-0 before:bg-gradient-action before:opacity-[0.05] before:z-0">
        <p className="relative z-10 text-sm text-gray-700">
          {context}
        </p>
        <Button size="sm" onClick={onChatClick} className="relative z-10 shrink-0">
          <MessageCircle className="h-3.5 w-3.5" />
          {buttonText}
        </Button>
      </div>
    </div>
  );
};
